import { render, staticRenderFns } from "./factory.vue?vue&type=template&id=a1996e74&scoped=true&"
import script from "./factory.vue?vue&type=script&lang=ts&"
export * from "./factory.vue?vue&type=script&lang=ts&"
import style0 from "./factory.vue?vue&type=style&index=0&id=a1996e74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1996e74",
  null
  
)

export default component.exports